import React from "react";
import styles from "./StandardPeopleTagList.module.scss";

interface StandardPeopleTagListProps {
  list: any[];
  selectedCrowdDataList: any;
}

const handleDragStart = (event: React.DragEvent<HTMLDivElement>, label: any) => {
  event.dataTransfer.setData("application/json", JSON.stringify(label));
};
//
const AudiencePackList: React.FC<StandardPeopleTagListProps> = ({ list = [], selectedCrowdDataList }) => {
  // 定义不可选集合
  const [unselectableList, setUnselectableList] = React.useState<any[]>([]);

  //监听selectedCrowdDataList
  React.useEffect(() => {
    const newUnselectableList = [...selectedCrowdDataList.audienceList, ...selectedCrowdDataList.unionCollectionList, ...selectedCrowdDataList.differenceCollectionList].map((item) => item.id);
    setUnselectableList(newUnselectableList);
  }, [selectedCrowdDataList]);

  return (
    <div className={styles["audiencePackTagList"]}>
      {list.length === 0 ? (
        <div className={styles["noData"]}>暂无数据</div>
      ) : (
        list.map((item: any, index: number) => {
          const isSelected = unselectableList.includes(item.id);
          return (
            <div key={index} style={{ color: "#bcbdc0", fontSize: "12px", lineHeight: "16px" }}>
              <div className={styles["audiencePackTag"]} aria-disabled={isSelected} draggable={!isSelected} onDragStart={(event) => handleDragStart(event, item)}>
                <div className={styles["labelName"]} style={{ color: isSelected ? '#bcbdc0' : '' }}>{item.name}</div>
                {item.name != item.description && <div className={styles["labelDesc"]}>{item.description}</div>}
              </div>
            </div>
          )
        })
      )}
    </div>
  );
};

export default AudiencePackList;
